import { ActionResultWithIds, Workflow } from 'hooks/useGruAgent/types';

type TFunction = (key: string, opts?: Record<string, unknown>) => string;

export type StatusMessage = {
  text: string;
  status: 'loading' | 'done';
};

// t('webedi:sidebar.agents.loading.done.fetchedMessage')
// t('webedi:sidebar.agents.loading.done.validated')
// t('webedi:sidebar.agents.loading.done.searchedRelated')
// t('webedi:sidebar.agents.loading.done.errorsFound')
const ACTION_DONE_KEYS: Record<string, string> = {
  fetch_message: 'webedi:sidebar.agents.loading.done.fetchedMessage',
  validate_message: 'webedi:sidebar.agents.loading.done.validated',
  propose_enrichment: 'webedi:sidebar.agents.loading.done.searchedRelated',
};

export const getStatusMessages = (actionResults: Array<ActionResultWithIds>, t: TFunction): Array<StatusMessage> => {
  const messages: Array<StatusMessage> = [];

  for (const ar of actionResults) {
    const doneKey = ACTION_DONE_KEYS[ar.action];
    if (doneKey) {
      messages.push({ text: t(doneKey), status: 'done' });
    }
    if (ar.action === 'validate_message' && ar.status === 'errors_found' && 'payload' in ar) {
      const errors = (ar.payload as { errors: Array<unknown> }).errors;
      messages.push({
        text: t('webedi:sidebar.agents.loading.done.errorsFound', { count: errors.length }),
        status: 'done',
      });
    }
  }

  return messages;
};

export const hasTerminalResult = (actionResults: Array<ActionResultWithIds>): boolean =>
  actionResults.some((ar) => ar.action === 'propose_enrichment');

export const hasCompletedSteps = (actionResults: Array<ActionResultWithIds>): boolean => actionResults.length > 0;

export const isWorkflowActive = (workflow: Workflow | null): boolean => workflow?.status === 'running';
